const area = document.querySelector( 'html' ).dataset.area;
const areaId = document.querySelector( 'html' ).dataset.areaId;
const endPoint = `${ area }/system/data/relewise-search`;

class RelewiseSearch extends HTMLElement {

  static get observedAttributes() {
    return ['query', 'show', 'loading'];
  }

  get query() {
    return this.getAttribute( 'query' );
  }

  set query( val ) {
    this.setAttribute( 'query', val );
  }

  get show() {
    return this.getAttribute( 'show' );
  }

  set show( val ) {
    this.setAttribute( 'show', val );
  }

  get loading() {
    return this.getAttribute( 'loading' );
  }

  set loading( val ) {
    this.setAttribute( 'loading', val );
  }

  constructor() {
    super();
    
    const template = this.querySelector( 'template' );
    if(template === null){
      return undefined;
    }
    this.clone = template.cloneNode( true );
    this.template = template.content;
    this.builder = new HTMLBuilder();
    this.settings = {
      productTake: 8,
      sidebarTake: 4,
    };
    this.areaId = areaId;
  }

  connectedCallback() {
    this.renderModal();
    this.bindInternalEvents();
    this.bindExternalEvents();
  }
  
  attributeChangedCallback( name, oldValue, newValue ) {
    if (oldValue === null || oldValue === newValue) return;
    if(typeof this[`${name}AttributeCallback`] === 'function'){
      this[`${name}AttributeCallback`](newValue);
    }
  }
  loadingAttributeCallback(value){
    this.loader( value === 'true' );
  }
  showAttributeCallback(value){
    if ( value === 'true' ) {
      this.showModal();
    } else {
      this.hideModal();
      this.clearModal();
    }
  }
  queryAttributeCallback(value){
    if ( value.length > 0 ) {
      this.show = true;
      this.search();
    } else {
      this.clearModal();
    }
  }
  bindInternalEvents(){
    const viewAllProductsButtons = this.querySelectorAll(
        '.js-view-all-products-btn' );

    viewAllProductsButtons.forEach(
        b => b.addEventListener( 'click', ( event ) => {
          event.preventDefault();
          location.href = `${ event.target.href }?term=${ this.query }&areaId=${this.areaId}`;
        } ) );

    this.querySelector( '.js-identity-relewise-search-input' )
        .addEventListener( 'input', this.debounce( ( event ) => {
          this.query = event.target.value;
        }, 500 ) );
  }
  bindExternalEvents() {
    document.querySelectorAll( '.js-search-trigger' )
        .forEach( b => b.addEventListener( 'click', ( event ) => {
          event.preventDefault();
          this.show = true;
        } ) );
    document.querySelectorAll( '.js-set-search-btn' )
        .forEach( b => b.addEventListener( 'click', ( event ) => {
          event.preventDefault();
          this.query = '';
          this.query = event.target.dataset.term;
        } ) );
  }

  renderModal() {
    this.innerHTML = '';
    this.appendChild( this.template );
  }

  beforeResultRender() {
    const resultElements = this.querySelectorAll(
        '.js-identity-relewise-search-results-categories, .js-identity-relewise-search-results-pages, .js-identity-relewise-search-results-predictions' );
    const productsElement = this.querySelector(
        '.js-identity-relewise-search-results-products' );
    const countElement = this.querySelector( '.js-product-count' );
    const viewAllProductsButtons = this.querySelectorAll( '.js-view-all-products-btn' );

    countElement.classList.add( 'd-none' );
    productsElement.innerHTML = '';
    productsElement.classList.add( 'd-none' );
    resultElements.forEach( r => r.classList.add( 'd-none' ) );
    viewAllProductsButtons.forEach( b => b.classList.add( 'd-none' ) );

  }

  renderResults( results ) {
    this.beforeResultRender();
    if ( results !== null ) {
      this.renderProducts( results.products, results.productHits );

      if ( results.categories.length > 0 ) {
        this.renderCategories( results.categories );
      }
      if ( results.pages.length > 0 ) {
        this.renderPages( results.pages );
      }
      if ( results.predictions.length > 0 ) {
        this.renderPredictions( results.predictions );
      }
    }
  }

  renderProducts( products, productHits ) {
    const resultElement = this.querySelector(
        '.js-identity-relewise-search-results-products' );
    const viewAllProductsButtons = this.querySelectorAll(
        '.js-view-all-products-btn' );
    const countElement = this.querySelector( '.js-product-count' );
    resultElement.innerHTML = '';
    products.forEach( ( product ) => {
      this.builder.create( 'div', {
        class: 'd-flex col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3',
      } ).content( product.listItemHtml ).appendTo( resultElement );
    } );
    resultElement.classList.remove( 'd-none' );

    if ( productHits > this.settings.productTake ) {
      viewAllProductsButtons.forEach( b => b.classList.remove( 'd-none' ) );
    } else {
      viewAllProductsButtons.forEach( b => b.classList.add( 'd-none' ) );
    }
    countElement.classList.remove( 'd-none' );

    if ( productHits > 0 ) {
      countElement.textContent = this.clone.content.querySelector( '.js-product-count' )
          .textContent
          .replace( '{{productPageSize}}', this.settings.productTake > productHits ? productHits : this.settings.productTake )
          .replace( '{{productHits}}', productHits );
    } else{
      countElement.textContent = this.clone.content.querySelector( '.js-product-count' ).dataset.noResults;
    }

  }

  renderCategories( categories ) {
    categories = [
      ...this.uniqueValues( categories,
          ( o1, o2 ) => o1.Value.DisplayName === o2.Value.DisplayName )];
    const resultElement = this.querySelector(
        '.js-identity-relewise-search-results-categories' );
    const resultElementList = resultElement.querySelector( 'ul' );
    resultElementList.innerHTML = '';
    categories.forEach( ( category ) => {
      const listElement = this.builder.create( 'li', {
        class: 'm-0 d-block',
      } ).style( { marginBottom: '0.5em' } ).toNode();
      this.builder.create( 'a',
          { href: `Default.aspx?ID=${ category.Value.Id }` } )
          .content( category.Value.DisplayName )
          .appendTo( listElement );
      resultElementList.appendChild( listElement );
    } );
    resultElement.classList.remove( 'd-none' );

  }

  renderPages( pages ) {
    pages = [
      ...this.uniqueValues( pages,
          ( o1, o2 ) => o1.DisplayName === o2.DisplayName )];
    const resultElement = this.querySelector(
        '.js-identity-relewise-search-results-pages' );
    const resultElementList = resultElement.querySelector( 'ul' );
    resultElementList.innerHTML = '';
    pages.forEach( ( page ) => {
      const listElement = this.builder.create( 'li', {
        class: 'm-0 d-block',
      } ).style( { marginBottom: '0.5em' } ).toNode();
      this.builder.create( 'a', { href: `Default.aspx?ID=${ page.ContentId }` } )
          .content( page.DisplayName )
          .appendTo( listElement );
      resultElementList.appendChild( listElement );
    } );
    resultElement.classList.remove( 'd-none' );
  }

  renderPredictions( predictions ) {
    const resultElement = this.querySelector(
        '.js-identity-relewise-search-results-predictions' );
    const resultElementList = resultElement.querySelector( 'ul' );
    resultElementList.innerHTML = '';
    predictions.forEach( ( prediction ) => {
      const listElement = this.builder.create( 'li', {
        class: 'm-0 d-block',
      } ).style( { marginBottom: '0.5em' } ).toNode();
      this.builder.create( 'a', { href: `#` } )
          .content( prediction.Term )
          .listener( 'click', ( event ) => {
            event.preventDefault();
            this.query = prediction.Term;
          } )
          .appendTo( listElement );
      resultElementList.appendChild( listElement );
    } );
    resultElement.classList.remove( 'd-none' );
  }

  search() {
    this.querySelector( '.js-identity-relewise-search-input' ).value = this.query;

    if ( this.aborter ) {
      this.aborter.abort( 'New request' );
    }
    this.aborter = new AbortController();
    const signal = this.aborter.signal;
    if ( this.query.length > 1 ) {
      this.loading = true;
      fetch(
          `${ endPoint }?q=${ this.query }&pagesize=${ this.settings.productTake }&areaId=${ areaId }`,
          { signal } ).then( resp => resp.json() ).then( ( json ) => {
        this.aborter = null;
        this.loading = false;
        this.renderResults( json );
      } ).catch( () => {
      } );
    }
  }

  clearModal() {
    this.renderResults( null );
    this.querySelector( '.js-identity-relewise-search-input' ).value = '';
  }

  showModal() {
    this.querySelector( '.js-identity-relewise-search-modal' )
        .classList
        .add( 'show', 'd-block' );
    this.querySelector( '.js-relewise-search-backdrop' )
        .classList
        .add( 'show' );
    document.body.style.overflow = 'hidden';
    setTimeout( () => {
      this.querySelector( '.js-identity-relewise-search-input' ).focus();
    }, 0 );
  }

  hideModal() {
    this.querySelector( '.js-identity-relewise-search-modal' )
        .classList
        .remove( 'show', 'd-block' );
    this.querySelector( '.js-relewise-search-backdrop' )
        .classList
        .remove( 'show' );
    document.body.style.overflow = '';
  }

  loader( isShow ) {
    const searchIcon = this.querySelector(
        '.js-identity-relewise-search-icon' );
    const loadingIcon = this.querySelector(
        '.js-identity-relewise-loading-icon' );
    if ( isShow ) {
      searchIcon.classList.add( 'd-none' );
      loadingIcon.classList.remove( 'd-none' );
    } else {
      searchIcon.classList.remove( 'd-none' );
      loadingIcon.classList.add( 'd-none' );
    }
  }

  debounce( fnCallback, timeout = 500 ) {
    let timer;
    return ( ...args ) => {
      clearTimeout( timer );
      timer = setTimeout( () => {
        fnCallback.apply( this, args );
      }, timeout );
    };
  }

  uniqueValues( array, condition ) {
    return array.filter(
        ( e, i ) => array.findIndex( e2 => condition( e, e2 ) ) === i );
  }
}

class HTMLBuilder {
  constructor() {
    this.value = '';
  }

  formatCamelCaseToDashed( str ) {
    return str.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
  }

  create( tagName, attributes = {} ) {
    const htmlElement = document.createElement( tagName );
    Object.keys( attributes ).forEach( key => htmlElement.setAttribute(
        this.formatCamelCaseToDashed( key ), attributes[key] ) );
    this.value = htmlElement;
    return this;
  }

  content( content ) {
    this.value.innerHTML = content;
    return this;
  }

  style( styles ) {
    Object.keys( styles ).forEach( key => this.value.style[key] = styles[key] );
    return this;
  }

  listener( event, fn ) {
    this.value.addEventListener( event, fn );
    return this;
  }

  wrapAround( childNode ) {
    this.value.append( childNode );
    return this;
  }

  appendTo( parentNode ) {
    parentNode.append( this.value );
  }

  prependTo( parentNode ) {
    parentNode.prepend( this.value );
  }

  toNode() {
    return this.value;
  }
}

customElements.define( 'relewise-search', RelewiseSearch );
